import { render, staticRenderFns } from "./Arquivadas.vue?vue&type=template&id=12d1ff88&lang=pug&"
import script from "./Arquivadas.vue?vue&type=script&lang=js&"
export * from "./Arquivadas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports